"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugSettingsProvider = void 0;
const React = __importStar(require("react"));
const ReactRedux = __importStar(require("react-redux"));
const Contexts = __importStar(require("../contexts"));
const Actions = __importStar(require("./actions"));
class debugSettingsProvider extends React.Component {
    constructor(props) {
        super(props);
        this.setDebugSettings = (includeServerLog, showHiddenProperties, showHiddenResults) => {
            this.props.dispatch(Actions.setDebugSettings(includeServerLog, showHiddenProperties, showHiddenResults));
        };
        this.state = {
            setDebugSettings: this.setDebugSettings,
            includeServerLog: props.includeServerLog,
            showHiddenProperties: props.showHiddenProperties,
            showHiddenResults: props.showHiddenResults
        };
    }
    static getDerivedStateFromProps(props, prevState) {
        if (props.includeServerLog !== prevState.includeServerLog ||
            props.showHiddenProperties !== prevState.showHiddenProperties ||
            props.showHiddenResults !== prevState.showHiddenResults) {
            return {
                includeServerLog: props.includeServerLog,
                showHiddenProperties: props.showHiddenProperties,
                showHiddenResults: props.showHiddenResults
            };
        }
        return null;
    }
    render() {
        const { children } = this.props;
        return (React.createElement(Contexts.DebugSettingsContext.Provider, { value: this.state }, children));
    }
}
function mapStateToProps(state) {
    return state.ui.debugSettings;
}
exports.DebugSettingsProvider = ReactRedux.connect(mapStateToProps)(debugSettingsProvider);
//# sourceMappingURL=debug-settings-provider.js.map